module.exports = __webpack_public_path__ + "static/img/申万宏源证券.ed1b886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/申万宏源证券.png
// module id = O3eJ
// module chunks = 3